/** @format */

import { EvergreenTemplateData } from './google-ad-manager.interface';

/* Ad Carousel Constants */
export const CDN_BASE_URL = 'https://images.dickssportinggoods.com/medianetwork';
export const NARROW_BANNER_PLACEHOLDER_IMG =
  'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="680" height="100"%3E%3C/svg%3E';
export const PLACEHOLDER_TEMPLATE_DATA: EvergreenTemplateData = {
  MAIN_IMG: NARROW_BANNER_PLACEHOLDER_IMG,
  MAIN_IMG_ALT: '',
  // headline cannot be empty for placeholder styling purposes
  HEADLINE: 'loading',
  HEADLINE_COLOR: '00000000',
  BG_COLOR: '00000000',
  CTA_TEXT: '',
  CTA_URL: '',
  CTA_TAB_BEHAVIOR: '_blank',
};
